import { addListener, showElements, hideElements } from "@grindex-common/helpers/domManipulation";
import PerformanceCurvesDom from "./performanceCurves.dom";
import { events } from "@grindex-common/helpers/events";
import TabNames from "@grindex-client/components/Tabs/TabNames.class";
import asyncModule from "@grindex-client/components/Module/asyncModule";

const SELECTOR_TAB_CONTENT = ".tab-content";
const SELECTOR_BUTTON_HOLDER = ".btnHolder";
const SELECTOR_BUTTON_DELETE = ".button-delete";

const CLASS_RIGHT = "right";
const CLASS_RESULT_WRAPPER = `results-wrapper--{0}-columns`;

const EVENT_CLICK = "click";
const EVENT_TOGGLE_CHANGE = "toggle:changed";
const EVENT_SCROLL = "scroll";
const EVENT_RESIZE = "resize";

const ATTRIBUTE_DATA_COLUMN_INDEX = "data-column-index";

let numCompareColumns = 0;

(function listenForEvent() {
	asyncModule("performancecurves", events.tabLoadedEvent(new TabNames().product.curves), init);
})();

function init($view) {
	const $moduleContainer = $view.closest(SELECTOR_TAB_CONTENT);
	const isComparePage = document.body.classList.contains("productCompare-page");

	const dom = new PerformanceCurvesDom($view);

	if ($moduleContainer) {
		const $toggleButtons = $moduleContainer.querySelectorAll(SELECTOR_BUTTON_HOLDER);

		if ($toggleButtons) {
			$toggleButtons.forEach(($toggleButton) => {
				addListener($toggleButton, EVENT_TOGGLE_CHANGE, applyToggleFilters);
				applyToggleFilters($toggleButton);
			});
		}
	}

	function initEvents() {
		addListener(dom.getButtonPager(), EVENT_CLICK, scrollContent);
		addListener(dom.getScrollElement(), EVENT_SCROLL, onScrollFreezeFirstColumn);
		addListener(window, EVENT_RESIZE, resizeTable);
	}

	function scrollContent(e) {
		const scrollAmt = dom.getScrollContainerLabel().offsetWidth;

		if (e.currentTarget.classList.contains(CLASS_RIGHT)) {
			dom.getScrollElement().scrollLeft += scrollAmt;
		} else {
			dom.getScrollElement().scrollLeft -= scrollAmt;
		}

		e.preventDefault();
		e.stopPropagation();
	}

	function resizeTable() {
		const $technicalSpecificationsContainer = dom.getTechSpecContainer();
		const $resultWrapper = dom.getResultWrapper();

		if (!$technicalSpecificationsContainer || !$resultWrapper) {
			return;
		}

		for (let i = 2; i < 10; i++) {
			$resultWrapper.classList.remove(String.format(CLASS_RESULT_WRAPPER, i));
		}

		const numberOfColumns = Math.floor($technicalSpecificationsContainer.offsetWidth / 159);
		const classToAdd = String.format(CLASS_RESULT_WRAPPER, numberOfColumns);

		$resultWrapper.classList.add(classToAdd);
	}

	function applyToggleFilters(evt) {
		const $button = evt.currentTarget || evt;
		const data = $button.dataset;
		const $module = $button.closest(SELECTOR_TAB_CONTENT);
		let showSelector = "";

		$module.querySelectorAll(SELECTOR_BUTTON_HOLDER).forEach(($toggleButton) => {
			const buttonData = $toggleButton.dataset;
			const showValue = buttonData[buttonData.isOn === "true" ? "on" : "off"];
			showSelector += `[data-filter-${buttonData.filter}="${showValue}"]`;
		});

		$module.querySelectorAll(`[data-filter-${data.filter}]`).forEach(($filter) => {
			$filter.classList.add("hidden");
			$filter.parentElement.classList.add("hidden");
		});

		$module.querySelectorAll(showSelector).forEach(($filter) => {
			$filter.classList.remove("hidden");
			$filter.parentElement.classList.remove("hidden");
		});
	}

	function onScrollFreezeFirstColumn(e) {
		e.currentTarget.querySelectorAll(".label").forEach(($lable) => {
			$lable.style.left = `${dom.getScrollElement().scrollLeft}px`;
		});
	}

	function render() {
		setUpColumnRemoval();
	}

	function setUpColumnRemoval() {
		// Current UI only allows user to delete a column if you are looking at the maximum number (3).
		// It doesn't make sense to compare 0 or 1 column, so you're not able to remove those.
		numCompareColumns = dom.getProductImageList().length;

		if (numCompareColumns === 3) {
			showElements(SELECTOR_BUTTON_DELETE);
			addListener(dom.getDeleteButtons(), EVENT_CLICK, deleteColumn);
		} else {
			hideElements(SELECTOR_BUTTON_DELETE);
		}
	}

	function removeChildElement($parentElement, $child) {
		$parentElement.removeChild($child);
		setUpColumnRemoval();
	}

	function deleteColumn(e) {
		const index = e.currentTarget.parentElement.getAttribute(ATTRIBUTE_DATA_COLUMN_INDEX);

		document.querySelectorAll(`.flex-container .data[data-column-index='${index}']`).forEach(($dataRow) => {
			removeChildElement($dataRow.parentElement, $dataRow);
		});
	}

	if (isComparePage) {
		render();
	}

	initEvents();
	resizeTable();
}

export default {
	view: "performancecurves",
	init,
};
